import { useAuth } from "../auth/authContext.tsx";
import type { EndPoint, InitCache, Session } from "../types/session.ts";

interface UseSessionResult {
  session: Session | null;
  cache: InitCache | null;
  endpoints: EndPoint[];
  activeEndpoint: EndPoint | null;
}

export function useSession(): UseSessionResult {
  const { session, cache, endpoints, activeEndpoint } = useAuth();
  return { session, cache, endpoints, activeEndpoint };
}
